export class TimeoutDialogMessage {
  title: string = "dialogTitle";
  message: string = "dialogMessage";
  timeout: string = "";
}
